<template>
    <div class="bacgroundColorsComponent">
        <ul class="backgroundColorsItems" v-if="label.backgroundcolors.length > 1" >
            <li v-for="backgroundcolor in label.backgroundcolors" v-bind:style="{ 'background-color': 'rgb('+ backgroundcolor.rgb+')'}" class="backgroundColorsItem cmpt" v-on:click="changeBackgroundColor(backgroundcolor)">
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        props    : ['label', 'backgroundcolors'],
        methods  : {
            changeBackgroundColor ( backgroundcolor ) {
                var params = {
                    record         : this.label,
                    backColorId : backgroundcolor.id
                }
                this.$store.dispatch( "changeBackgroundColor", params );
            }
        },
        computed : {
            getStyle () {
                return {
                    'background-color' : 'rgb(' + this.backgroundcolor.rgb + ')'
                };
            }
        }
    }
</script>
<style>
    .backgroundColorsItem {
        display       : block;
        border        : 2px solid #FFFFFF;
        border-radius : 100%;
        width         : 22px;
        height        : 22px;
        border-radius : 50%;
        float         : left;
        cursor        : pointer;
        margin-left   : 5px;
    }

    .backgroundColorsItems {
        margin: 0;
        list-style: none;
        display: inline-block;
        justify-content: center;
        padding: 5px 0 6px;
        padding-bottom: 15px;
    }
    .bacgroundColorsComponent{
        width    : 100%;
        display : inline-block;
        text-align:center;
    }
    .option-list{
        width:100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/BackgroundsColors/BackgroundColors.vue